import { thunk, Thunk } from "easy-peasy";
import { BackgroundJob as backgroundJobSdk } from "coolremote-sdk";

export interface IBackgroundJobModel {
    getBackgroundJobById: Thunk<IBackgroundJobModel, string>;
}

export const backgroundJobsModel: IBackgroundJobModel = {
    getBackgroundJobById: thunk(async (actions, payload) => {
        return backgroundJobSdk.getBackgroundJobById(payload);
    }),
}
